import React, { useState, useEffect } from 'react';

const slides = [
  { 
    id: 1, 
    title: "iCloud & FRP Bypass", 
    sub: "خدمات تخطي حسابات جوجل وآيكلود مضمونة", 
    icon: "🔓",
    bg: "linear-gradient(135deg, #be123c, #fb7185)" // لون أحمر يوحي بفك القفل
  },
  { 
    id: 2, 
    title: "Computer Sales & Repair", 
    sub: "بيع وصيانة الحواسيب (Laptops & PC)", 
    icon: "💻",
    bg: "linear-gradient(135deg, #1e3a8a, #3b82f6)" // أزرق تقني
  },
  { 
    id: 3, 
    title: "Software & Flashing", 
    sub: "تفليش، فك شفرة، وإصلاح أخطاء النظام", 
    icon: "📲",
    bg: "linear-gradient(135deg, #047857, #34d399)" // أخضر
  },
  { 
    id: 4, 
    title: "Server Services", 
    sub: "شحن رصيد البوكسات وتفعيل السيرفرات", 
    icon: "🌍",
    bg: "linear-gradient(135deg, #7c3aed, #a78bfa)" // بنفسجي
  }
];

const ImageSlider = () => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => { setIndex((prev) => (prev + 1) % slides.length); }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{ height: '220px', borderRadius: '20px', overflow: 'hidden', position: 'relative', marginBottom: '30px', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' }}>
      {slides.map((slide, i) => (
        <div key={slide.id} style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          background: slide.bg, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          color: 'white', textAlign: 'center', opacity: i === index ? 1 : 0, transition: 'opacity 1s ease-in-out'
        }}>
          <div style={{ fontSize: '60px', marginBottom: '10px', filter: 'drop-shadow(0 5px 10px rgba(0,0,0,0.3))' }}>{slide.icon}</div>
          <h2 style={{ fontSize: '32px', margin: 0, textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>{slide.title}</h2>
          <p style={{ fontSize: '18px', opacity: 0.9, marginTop: '5px', background: 'rgba(0,0,0,0.2)', padding: '5px 15px', borderRadius: '15px' }}>{slide.sub}</p>
        </div>
      ))}
      <div style={{ position: 'absolute', bottom: '10px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '5px' }}>
        {slides.map((_, i) => (<div key={i} style={{ width: '10px', height: '10px', borderRadius: '50%', background: i === index ? 'white' : 'rgba(255,255,255,0.5)', transition: '0.3s' }}></div>))}
      </div>
    </div>
  );
};
export default ImageSlider;